import { PageHeader } from '../../components/layout/WorkspaceShell';
import { Card, Badge } from '../../components/ui/primitives';
import Btn from '../../components/ui/Btn';
import { Icon } from '../../components/ui/Icon';

/**
 * Branded "Coming soon" placeholder rendered inside the workspace shell.
 *
 * Props:
 *   - title:      page title (e.g. "Automations")
 *   - subtitle:   page subtitle
 *   - icon:       icon component to feature
 *   - features:   bulleted list of what the page will do (for marketing-style preview)
 *   - phase:      optional phase number for the README cross-reference
 */
export default function ComingSoonPanel({ title, subtitle, icon: I, features = [], phase }) {
  return (
    <>
      <PageHeader
        title={title}
        subtitle={subtitle}
      />

      <Card style={{
        padding: 0, overflow: 'hidden',
        background: 'linear-gradient(135deg, var(--accent-bg) 0%, var(--surface) 60%)',
      }}>
        <div style={{ padding: '40px 32px' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 24, flexWrap: 'wrap' }}>
            <div style={{
              width: 72, height: 72, borderRadius: 18,
              background: 'var(--accent)', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
              boxShadow: '0 8px 24px rgba(61,199,91,0.25)',
            }}>
              {I && <I size={32} />}
            </div>

            <div style={{ flex: 1, minWidth: 280 }}>
              <div style={{ marginBottom: 10 }}>
                <Badge variant="accent" dot>Coming soon</Badge>
              </div>
              <h2 style={{
                fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em',
                color: 'var(--text)', marginBottom: 8,
              }}>
                {title} — coming to MagicIntake soon
              </h2>
              <p style={{ fontSize: 14, color: 'var(--text-2)', lineHeight: 1.6, marginBottom: 18 }}>
                We're building this. Want to be first in line when it ships?
                Email us and we'll let you know — and ask what you'd want it to do.
              </p>

              <Btn
                variant="primary"
                size="md"
                icon={Icon.mail}
                onClick={() => {
                  window.location.href = `mailto:hello@magicintake.com?subject=Interested in ${encodeURIComponent(title)}`;
                }}
              >
                Get notified
              </Btn>
            </div>
          </div>

          {features.length > 0 && (
            <div style={{
              marginTop: 32, padding: 24,
              background: 'var(--surface)', border: '1px solid var(--border)',
              borderRadius: 'var(--r-lg)',
            }}>
              <div style={{
                fontSize: 11, fontWeight: 700, color: 'var(--text-3)',
                letterSpacing: '0.08em', marginBottom: 14,
              }}>
                WHAT WE'RE BUILDING
              </div>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
                gap: 16,
              }}>
                {features.map((f, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                    <div style={{
                      width: 22, height: 22, borderRadius: 6,
                      background: 'var(--accent-bg)', color: 'var(--accent-600)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0, marginTop: 1,
                    }}>
                      <Icon.check size={12} />
                    </div>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>
                        {f.title}
                      </div>
                      {f.desc && (
                        <div style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 2 }}>
                          {f.desc}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Card>
    </>
  );
}
